
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { ResponsiveConfiguration } from "@/types/block-configurations";

interface ResponsiveControlsProps {
  value: ResponsiveConfiguration;
  onChange: (value: ResponsiveConfiguration) => void;
}

export function ResponsiveControls({ value, onChange }: ResponsiveControlsProps) {
  const updateField = <K extends keyof ResponsiveConfiguration>(
    field: K,
    newValue: ResponsiveConfiguration[K]
  ) => {
    onChange({ ...value, [field]: newValue });
  };

  return (
    <div className="space-y-2.5">
      {/* Visibility Toggles */}
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-1.5">
          <input
            type="checkbox"
            id="hide-mobile"
            checked={value.hideOnMobile}
            onChange={(e) => updateField('hideOnMobile', e.target.checked)}
            className="w-3.5 h-3.5 rounded border-input"
          />
          <Label htmlFor="hide-mobile" className="text-xs cursor-pointer">
            Hide mobile
          </Label>
        </div>
        <div className="flex items-center gap-1.5">
          <input
            type="checkbox"
            id="hide-desktop"
            checked={value.hideOnDesktop}
            onChange={(e) => updateField('hideOnDesktop', e.target.checked)}
            className="w-3.5 h-3.5 rounded border-input"
          />
          <Label htmlFor="hide-desktop" className="text-xs cursor-pointer">
            Hide desktop
          </Label>
        </div>
      </div>

      {/* Compact Device Status */}
      <div className="flex items-center gap-3 px-2 py-1.5 bg-muted rounded text-xs">
        <span className="flex items-center gap-1">
          <MobileIcon className={value.hideOnMobile ? 'text-muted-foreground' : 'text-foreground'} />
          {value.hideOnMobile ? 'Hidden' : 'Visible'}
        </span>
        <span className="flex items-center gap-1">
          <DesktopIcon className={value.hideOnDesktop ? 'text-muted-foreground' : 'text-foreground'} />
          {value.hideOnDesktop ? 'Hidden' : 'Visible'}
        </span>
      </div>
    </div>
  );
}

function MobileIcon({ className }: { className?: string }) {
  return (
    <svg className={`w-4 h-4 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
      />
    </svg>
  );
}

function DesktopIcon({ className }: { className?: string }) {
  return (
    <svg className={`w-4 h-4 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
      />
    </svg>
  );
}
